import { Pipe, PipeTransform } from '@angular/core';

import { NotificationTypeEnum } from '@modules/notification/enums/notification-type.enum';
import { NotificationInterface } from '@modules/notification/models/notification.interface';

/**
 * Resolves notification toast header with fallback based on notification type.
 */
@Pipe({
  name: 'notificationToastHeader',
  standalone: true,
})
export class NotificationToastHeaderPipe implements PipeTransform {
  /**
   * Returns notification title or fallback title based on type.
   * @param notification - notification message
   */
  transform(notification: NotificationInterface): string {
    if (notification.title) {
      return notification.title;
    }

    switch (notification.type) {
      case NotificationTypeEnum.SUCCESS:
        return 'Success';
      case NotificationTypeEnum.ERROR:
        return 'Error';
      case NotificationTypeEnum.WARNING:
        return 'Warning';
      case NotificationTypeEnum.INFO:
      default:
        return 'Info';
    }
  }
}
